// Статичная подложка карты Баку для пустого состояния мини-карты на телефоне
// и планшете (≤ 980px): картинка Google Maps Static API, а не JS-карта.
// Ключ — тот же браузерный GOOGLE_MAPS_BROWSER_KEY, что у карты /tutors
// (getMapsBrowserKey). Картинка запрашивается у Google напрямую — в репозитории
// и на нашем сервере её копий нет (условия Google Maps).
//
// Если у ключа не включён Static API или ключа нет, Google вместо карты отдаёт
// картинку-ошибку другого размера (или запрос падает): HomeDoors проверяет
// naturalWidth/naturalHeight и onerror и тогда оставляет нейтральный фон.

/** Центр и зум — те же, что у MapCanvas (BAKU, zoom 12); сверяет verify-home-doors. */
export const BAKU_CENTER = "40.4093,49.8671";
export const BAKU_ZOOM = 12;
/** Размер в CSS-пикселях (картинка растягивается object-fit: cover) и scale=2. */
export const STATIC_MAP_SIZE = { width: 480, height: 280, scale: 2 } as const;

/** Подписи POI и бизнес скрыты — тот же стиль, что MAP_STYLES в MapCanvas. */
export const STATIC_MAP_STYLES = [
  "feature:poi|element:labels|visibility:off",
  "feature:poi.business|visibility:off",
] as const;

export function staticMapUrl(key: string, lang: "az" | "ru" | "en"): string {
  const q = new URLSearchParams({
    center: BAKU_CENTER,
    zoom: String(BAKU_ZOOM),
    size: `${STATIC_MAP_SIZE.width}x${STATIC_MAP_SIZE.height}`,
    scale: String(STATIC_MAP_SIZE.scale),
    language: lang,
    region: "AZ",
    key,
  });
  // Без точек интереса — как MapCanvas (MAP_STYLES): style повторяется.
  for (const st of STATIC_MAP_STYLES) q.append("style", st);
  return `https://maps.googleapis.com/maps/api/staticmap?${q.toString()}`;
}

/** Настоящая карта, а не картинка-ошибка: размер ровно запрошенный × scale. */
export const isRealStaticMap = (w: number, h: number) =>
  w === STATIC_MAP_SIZE.width * STATIC_MAP_SIZE.scale && h === STATIC_MAP_SIZE.height * STATIC_MAP_SIZE.scale;
